import appConfig from "../../app-config";

const CompanyStorage = {
    getItems(key) {
        return localStorage.getItem(key);
    },
    saveItems(key, value) {
        localStorage.setItem(key, value);
    },
    clear() {
        localStorage.removeItem(`companyName_${appConfig.VUE_APP_COOKIE_NAME}`);
    },
};

export { CompanyStorage };
